import React, { ComponentProps } from "react";
import { Route, withRouter, RouteComponentProps } from "react-router-dom";

import { fomatParentPath } from "../../utils";
import { MobRecommend } from "../../lib";

function Recommend(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route
      weId={`${props.weId || ""}_y1jtw3`}
      exact
      path={`${parentPath}/mobile/uk/recommend`}
    >
      {<MobRecommend weId={`${props.weId || ""}_lzafwp`} />}
    </Route>
  );
}

export default withRouter(Recommend);
